import { createContext, useContext, useState } from "react";

const PersonasContext = createContext([] as any);

const PersonasContextProvider = ({ children }: any) => {
  const [selectedPersonas, setSelectedPersonas] = useState([]);

  return (
    <PersonasContext.Provider
      value={{
        selectedPersonas,
        setSelectedPersonas,
      }}
    >
      {children}
    </PersonasContext.Provider>
  );
};

const usePersonasContext = () => {
  const context = useContext(PersonasContext);

  if (!context) {
    throw new Error("usePersonasContext was used outside of its Provider");
  }

  return context;
};

export { PersonasContextProvider, usePersonasContext };
